// extracted by mini-css-extract-plugin
module.exports = {"img":"EventPopup_img_3WdbZ","closeBtn":"EventPopup_closeBtn_ITf2n"};